// extracted by mini-css-extract-plugin
module.exports = {"ratingLink":"Rating_ratingLink__JPEd5","sm":"Rating_sm__iAj1g","ratingAndReviews":"Rating_ratingAndReviews__tLKrU"};